import Typography from '@mui/material/Typography';

import { ensureDefined } from '@e-socna/utils';

import { ResolvableQuantity } from '../../ResolvableFields/ResolvableQuantity';
import type { ResolvableFieldSettings } from '../../ResolvableFields/types/resolvable-field-settings.type';

import { buildDisplayParameters } from './utils/build-display-parameters.util';
import type { ServiceUsageCardCmp_ResolvableServiceUsage } from './fragments/resolvable-service-usage.fragment';

interface Props {
  readonly resolvableFieldSettings: Partial<ResolvableFieldSettings>;
  readonly serviceUsage: ServiceUsageCardCmp_ResolvableServiceUsage;
}

export const ResolvableServiceUsageInfos = ({
  resolvableFieldSettings,
  serviceUsage,
}: Readonly<Props>) => {
  const { quantity } = ensureDefined({ quantity: serviceUsage.quantity });

  const parameters = buildDisplayParameters(resolvableFieldSettings);

  return (
    <>
      <Typography color="text.secondary" variant="overline">
        Informations Prestation
      </Typography>
      <Typography component="div" gutterBottom variant="body2">
        Quantité :{' '}
        <ResolvableQuantity
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
          resolvableQuantity={quantity}
        />
      </Typography>
    </>
  );
};
